module.exports = __webpack_public_path__ + "img/p2-69.b7c7ab0d.png";